// Lee el pulso y lo vuelve a pedir cada minuto mientras la oficina está abierta. Pedirlo es barato
// (nunca espera a ClickHouse) y es lo que le dice al servidor que alguien mira: sin peticiones, deja
// de consultar.
import { useEffect, useState } from 'react';
import { salaApi } from './api';
import type { PulsoSala } from './tipos';

export const CADA_MS = 60_000;

export function useSalaPulso(cadaMs = CADA_MS): { pulso: PulsoSala | null; fallo: boolean } {
  const [pulso, setPulso] = useState<PulsoSala | null>(null);
  const [fallo, setFallo] = useState(false);
  useEffect(() => {
    let vivo = true;
    const pedir = () =>
      salaApi
        .pulso()
        .then((p) => {
          if (!vivo) return;
          setPulso(p);
          setFallo(false);
        })
        .catch(() => vivo && setFallo(true));
    void pedir();
    const id = setInterval(pedir, cadaMs);
    return () => {
      vivo = false;
      clearInterval(id);
    };
  }, [cadaMs]);
  return { pulso, fallo };
}
